export default __webpack_public_path__ + "static/media/recoverypad_logo.7490cb90.png";